// extracted by mini-css-extract-plugin
export var shake = "_r-0";